import React from 'react';
import {
  Modal,
  ModalBody
} from "reactstrap";
import { useTranslation } from "react-i18next";

const SaveFileModal = ({ show, setShow, onSaveClickHandler }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={show} centered={true}>
        <ModalBody className="py-3 px-5">
            <div className="mt-2 text-center">
                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4>{t('areYouSure')}</h4>
                    <p className="text-muted mx-4 mb-0">{t('Are you sure you want to save this document?')}</p>
                </div>
            </div>
            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                    type="button"
                    className="btn w-sm btn-light"
                    data-bs-dismiss="modal"
                    onClick={() => setShow(false)}
                >
                    {t("Close")}
                </button>
                <button
                    type="button"
                    className="btn w-sm btn-danger d-flex align-items-center"
                    onClick={onSaveClickHandler}
                >
                    {t('Yes, Save it')}
                </button>
            </div>
        </ModalBody>
    </Modal>
  )
}

export default SaveFileModal
